import { LayoutProps } from "@jsonforms/core";
import React from "react";

export const BaseLayoutContext = React.createContext<LayoutProps>({
  direction: "column",
  uischema: { type: "VerticalLayout" },
  schema: {},
  enabled: true,
  visible: true,
  path: "",
});
